"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "@/components/ui/CardImage";
import { getTimeAgo, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  userName?: FieldConfig;
  userType?: FieldConfig;
  timeAgo?: FieldConfig;
  commentText?: FieldConfig;
  userImage?: FieldConfig;
  /** Mark as LCP image - preloads for faster rendering */
  priority?: boolean;
  imageMetadata?: ImageMetadata;
};
export default function HorizontalCommentsNews(t0) {
  const $ = _c(43);
  const {
    userName: t1,
    userType: t2,
    timeAgo: t3,
    commentText: t4,
    userImage: t5,
    priority: t6,
    imageMetadata
  } = t0;
  let t7;
  if ($[0] !== t1) {
    t7 = t1 === undefined ? {
      hidden: false,
      value: "\u0BB8\u0BCD\u0BB0\u0BC0\u0BA8\u0BBF\u0BB5\u0BBE\u0BB8\u0BCD",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const userName = t7;
  let t8;
  if ($[2] !== t2) {
    t8 = t2 === undefined ? {
      hidden: false,
      value: "\u0B9A\u0BC6\u0BA9\u0BCD\u0BA9\u0BC8",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const userType = t8;
  let t9;
  if ($[4] !== t3) {
    t9 = t3 === undefined ? {
      hidden: false,
      value: "2 mins ago",
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  const timeAgo = t9;
  let t10;
  if ($[6] !== t4) {
    t10 = t4 === undefined ? {
      hidden: false,
      value: "\u0B95\u0BC1\u0BB1\u0BBF\u0BAA\u0BCD\u0BAA\u0BBE\u0B95 \u0BAE\u0BA4\u0BCD\u0BA4\u0BBF\u0BAF \u0B95\u0BBF\u0BB4\u0B95\u0BCD\u0B95\u0BBF\u0BB2\u0BBF\u0BB0\u0BC1\u0BA8\u0BCD\u0BA4\u0BC1 \u0BA4\u0BAE\u0BBF\u0BB4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0B9A\u0BC1\u0B9F \u0BB5\u0BBF\u0BB5\u0BB0\u0B95\u0BC2\u0B9F\u0BBE\u0BAE\u0BBE\u0BA9 \u0B95\u0B9F\u0BA4\u0BCD\u0BA4\u0BB2\u0BCD \u0BA8\u0B9F\u0BB5\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC8\u0B95\u0BB3\u0BCD \u0BAA\u0BBE\u0BB0\u0BB2\u0BBF\u0BAE\u0BC1\u0BB1\u0BA4\u0BC1 \u0B86\u0B9A\u0BBE\u0BB0\u0BBF\u0BAF\u0BAE\u0B9F\u0BB2\u0BCD",
      customClass: ""
    } : t4;
    $[6] = t4;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const commentText = t10;
  let t11;
  if ($[8] !== t5) {
    t11 = t5 === undefined ? {
      hidden: false,
      value: "/dinamani/default-avatar.png",
      customClass: ""
    } : t5;
    $[8] = t5;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const userImage = t11;
  const priority = t6 === undefined ? false : t6;
  const userNameValue = userName?.value || "";
  const userTypeValue = userType?.value || "";
  const t12 = timeAgo?.value;
  let t13;
  if ($[10] !== t12) {
    t13 = getTimeAgo(t12);
    $[10] = t12;
    $[11] = t13;
  } else {
    t13 = $[11];
  }
  const timeAgoValue = t13;
  const commentTextValue = commentText?.value || "";
  const userImageValue = userImage?.value || "/dinamani/default-avatar.png";
  let t14;
  if ($[12] !== imageMetadata || $[13] !== priority || $[14] !== userImage?.customClass || $[15] !== userImage?.hidden || $[16] !== userImageValue || $[17] !== userNameValue) {
    t14 = !userImage?.hidden && <div className={`flex-shrink-0 ${userImage?.customClass || ""}`}><div className="relative w-[42px] h-[42px] rounded-full bg-gray-200 overflow-hidden"><Image src={userImageValue} alt={`${userNameValue}'s profile`} fill={true} priority={priority} sizes="42px" className="object-cover" style={getFocusPointStyle(imageMetadata)} loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"} placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div></div>;
    $[12] = imageMetadata;
    $[13] = priority;
    $[14] = userImage?.customClass;
    $[15] = userImage?.hidden;
    $[16] = userImageValue;
    $[17] = userNameValue;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== userName?.customClass || $[20] !== userName?.hidden || $[21] !== userNameValue) {
    t15 = !userName?.hidden && <h3 className={`text-16-tamil-700 text-1B1B1B ${userName?.customClass || ""}`}>{userNameValue}</h3>;
    $[19] = userName?.customClass;
    $[20] = userName?.hidden;
    $[21] = userNameValue;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== timeAgo?.customClass || $[24] !== timeAgo?.hidden || $[25] !== timeAgoValue || $[26] !== userType?.customClass || $[27] !== userType?.hidden || $[28] !== userTypeValue) {
    t16 = (!userType?.hidden || !timeAgo?.hidden) && <span className="text-12-tamil-400 text-808080 ">{!userType?.hidden && <span className={userType?.customClass || ""}>{userTypeValue}</span>}{!userType?.hidden && !timeAgo?.hidden && " \xB7 "}{!timeAgo?.hidden && <span className={timeAgo?.customClass || ""}>{timeAgoValue}</span>}</span>;
    $[23] = timeAgo?.customClass;
    $[24] = timeAgo?.hidden;
    $[25] = timeAgoValue;
    $[26] = userType?.customClass;
    $[27] = userType?.hidden;
    $[28] = userTypeValue;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t15 || $[31] !== t16) {
    t17 = <div className=" items-center gap-2">{t15}{t16}</div>;
    $[30] = t15;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== commentText?.customClass || $[34] !== commentText?.hidden || $[35] !== commentTextValue) {
    t18 = !commentText?.hidden && <p className={`mt-1 text-14-tamil-400 text-4D4D4D leading-[1.4] line-clamp-2 ${commentText?.customClass || ""}`}>{commentTextValue}</p>;
    $[33] = commentText?.customClass;
    $[34] = commentText?.hidden;
    $[35] = commentTextValue;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t17 || $[38] !== t18) {
    t19 = <div className="flex-1 flex flex-col gap-2">{t17}{t18}</div>;
    $[37] = t17;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t14 || $[41] !== t19) {
    t20 = <article className="p-4"><div className="flex items-start gap-3">{t14}{t19}</div></article>;
    $[40] = t14;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  return t20;
}